export interface Field {
  id: string;
  name: string;
  required?: boolean;
  type?: string;
}

export type Form = {
  [key: string]: any;
};

export function checkEmptyRequiredFields(
  inputFields: Field[],
  form: Form,
): Field[] {
  const requiredFields = inputFields.filter((field) => field.required);
  const emptyRequiredFields = requiredFields.filter((field) => !form[field.id]);
  return emptyRequiredFields;
}
